import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { LicensedSection } from './components/LicensedSection';
import { ServicesSection } from './components/ServicesSection';
import { WorkGallery } from './components/WorkGallery';
import { ServiceAreaSection } from './components/ServiceAreaSection';
import { ReviewsSection } from './components/ReviewsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { ScheduleFormSection } from './components/ScheduleFormSection';
import { FloatingCallButton } from './components/FloatingCallButton';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex min-h-full w-full flex-col bg-white" data-id="element-0" data-mp="23u9u0nodldxa">
      <Header data-id="element-1" data-mp="3ijxoypkvdyjd" />
      <main className="flex-1" data-id="element-2" data-mp="3ikha0f5th31m">
        <Hero data-id="element-3" data-mp="3ij61y35c994p" />
        <ServicesSection data-id="element-4" data-mp="3ijpcuzwkmx98" />
        <ProblemSection data-id="element-5" data-mp="3mljaezbgzl56" />
        <LicensedSection data-id="element-6" data-mp="3mkrd9k285fcs" />
        <WorkGallery data-id="element-7" data-mp="3mk83iqmq9x9u" />
        <ServiceAreaSection data-id="element-8" data-mp="3mjgannkimdn9" />
        <ReviewsSection data-id="element-9" data-mp="3rcj6k2crlz6m" />
        <GuaranteeSection data-id="element-10" data-mp="3rdaqgfx028h2" />
        <OfferSection data-id="element-11" data-mp="3rcsuzli5vya7" />
        <FaqSection data-id="element-12" data-mp="3relvej26lm9r" />
        <ScheduleFormSection data-id="element-13" data-mp="5os92t1uy7l" />
        <FinalCta data-id="element-14" data-mp="4wylxj0jajy" />
      </main>
      <Footer data-id="element-15" data-mp="82kz509bybz" />
      <FloatingCallButton data-id="element-16" data-mp="7sxpp6lk59z" />
    </div>;
}